import baseApi from '@store/api/baseApi';

export const designDetailsApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getMachingCount: builder.query({
			query: (params) => `/material/pair-material-count${params}`
		})
	})
});

export const { useGetMachingCountQuery } = designDetailsApi;
